import { Component, OnInit, ElementRef, OnDestroy, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
// import { Socket } from 'ngx-socket-io';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
// import { getConnectedStatus, getDisconnectedCounter } from '../../../store/reducers/system';
// import * as systemActions from '../../../store/actions/system';
// import * as vpoActions from '../../../store/actions/vpo';
// import * as structureActions from '../../../store/actions/structure';


const fireRefreshEventOnWindow = function () {
  const evt = document.createEvent('HTMLEvents');
  evt.initEvent('resize', true, false);
  window.dispatchEvent(evt);
};


@Component({
  selector: 'app-main-html-layout',
  templateUrl: './main-html-layout.component.html',
  styleUrls: ['./main-html-layout.component.css']
})
export class MainHtmlLayoutComponent implements OnInit, OnDestroy, AfterContentChecked  {

  options = {
    direction: 'ltr'
  };

  // app messages
  messageError: any;
  messageSuccess: any;
  isConnected: boolean = true;
  // disconnectedCounter: number;
  protected subscribers: Array<any> = [];

  constructor(
      private elementRef: ElementRef,
      // private socket: Socket,
      private store: Store<fromRoot.AppState>,
      private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    // this.socket.on('connect', () => {
    //   setTimeout(() => {
    //     this.setConnectionOn();
    //   }, 10000);
    // });
    // this.socket.on('connect_error', () => this.setConnectionOff());
    // this.socket.on('dbConnectionError', () => this.setConnectionOff());
    // this.socket.on('dbConnectionOk', () => this.setConnectionOn());
    // this.socket.on('disconnect', () => this.setConnectionOff());
    // this.subscribers.push(this.store
    //     .pipe(
    //         select(fromRoot.selectSystemState())
    //     )
    //     .subscribe((state: any) => {
    //       this.disconnectedCounter = getDisconnectedCounter(state);
    //       const status = getConnectedStatus(state);
    //       if (status) {
    //         this.isConnected = status;
    //       } else {
    //         if (this.isConnected && this.disconnectedCounter > 25) {
    //           this.isConnected = status;
    //         }
    //       }
    //     }));
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy() {
    this.subscribers.forEach(s => s.unsubscribe());
  }

  // private setConnectionOff() {
  //   this.store.dispatch(new systemActions.SetDisConnectedCounter(this.disconnectedCounter + 1));
  //   if (this.isConnected) {
  //     this.store.dispatch(new systemActions.SetConnectedStatus(false));
  //   }
  // }
  //
  // private setConnectionOn() {
  //   if (!this.isConnected) {
  //     this.store.dispatch(new vpoActions.LoadAll());
  //     this.store.dispatch(new structureActions.LoadAll());
  //     this.store.dispatch(new systemActions.SetConnectedStatus(true));
  //     this.store.dispatch(new systemActions.SetDisConnectedCounter(0));
  //   }
  // }

}
